// extracted by mini-css-extract-plugin
export default {"signInLogo":"with-authentication_signInLogo__4439y","panel":"with-authentication_panel__6MKS3","row":"with-authentication_row__xY7l1"};